// ------------------------------------------------------------------
// PURE MODULE: classic_opacity.mod.js
// ------------------------------------------------------------------
import gsap from "gsap"; 

export function ClassicOpacity(item, index, animTarget) {
  ///////////////////////// MODULE: CLASSIC OPACITY /////////////////////////

  // Access the static config object attached to the function
  const config = ClassicOpacity.config;

  // [NEW] Determine the target. 
  // If a specific target is passed, use it. Otherwise fallback to item.image.
//  const animTarget = target || item.image;

  if (!animTarget) return; // Safety check

  /**
   * Main setup function
   * Called from setupAnimations(), for each carousel item
   */
  // Ensure animationState exists on the main item (the controller)
  item.animationState = item.animationState || {};

  // 1. Initial visibility flag
  item.animationState.slideFade = index === 0 ? 'visible' : 'hidden';

  // 2. Fade-IN TIMELINE
  // We animate the specific target, but store the controller on the parent item
  item.animationState.fadeInTween = gsap.timeline({ paused: true, overwrite: true })
    .to(animTarget, {
      opacity: 1,
      duration: config.duration,
      ease: config.easeIn
    }, 0);

  // 3. Fade-OUT TIMELINE
  item.animationState.fadeOutTween = gsap.timeline({ paused: true, overwrite: true })
    .to(animTarget, {
      opacity: 0,
      duration: config.duration,
      ease: config.easeOut
    }, 0);

  // 4. Initial state setup
  gsap.set(animTarget, { opacity: index === 0 ? 1 : 0 });
}

// Define Default Config externally so Master JS can modify it
ClassicOpacity.config = {
    duration: 1,
    easeIn: "power2.out",
    easeOut: "power2.in"
};